// Global-search backend seam (dependency inversion).
//
// The design system's server-mode table search needs to turn a free-text
// query into a `CrudFilters` constraint. The real implementation of that
// lives in the app (`src/hooks/useGlobalSearchFilter.ts`) because it calls
// the `global_search` RPC via `@services` — data access that ds must not
// reach for (boundary rule A). Instead, ds declares the seam here and the
// app registers the concrete backend at boot (`src/App.tsx`).

import type { CrudFilters } from "@refinedev/core";

export type GlobalSearchFilterFn = (
  query: string,
  entity: string,
) => Promise<CrudFilters>;

let impl: GlobalSearchFilterFn = () => {
  throw new Error(
    "global search backend not registered — App.tsx must call setGlobalSearchFilterBackend",
  );
};

export function setGlobalSearchFilterBackend(fn: GlobalSearchFilterFn): void {
  impl = fn;
}

export function buildGlobalSearchFilter(
  query: string,
  entity: string,
): Promise<CrudFilters> {
  return impl(query, entity);
}
